<template>
    <el-card class="box-card">
        <div class="component-content">
            <section class="content">
                <div>
                    <el-tabs v-model="activeName">
                        <el-tab-pane name="first" label="客服邮件查询">
                            <el-table :data="dataHandled" border>
                                <el-table-column type="expand">
                                    <template slot-scope="props">
                                        <el-form label-position="left" inline class="demo-table-expand">
                                            <el-descriptions border title="玩家信息" v-for="item in JSON.parse(props.row.playersJson)" :key="item.userId">
                                                <el-descriptions-item label="用户名">{{item.nick}}</el-descriptions-item>
                                                <el-descriptions-item label="sid">{{item.email}}</el-descriptions-item>
                                                <el-descriptions-item label="IP">{{item.ipPort}}</el-descriptions-item>
                                                <el-descriptions-item label="玩家ID">{{item.userId}}</el-descriptions-item>
                                                <el-descriptions-item label="服务器ID">{{item.serverId}}</el-descriptions-item>
                                            </el-descriptions>

                                            <div style="margin-top: 20px;" v-for="(value,key) in JSON.parse(props.row.contentJson)" :key="key">
                                                <el-descriptions border :title="key + '邮件内容'" v-if="value.title !== ''">
                                                    <el-descriptions-item label="标题">{{value.title}}</el-descriptions-item>
                                                    <el-descriptions-item label="发件人">{{value.sender}}</el-descriptions-item>
                                                    <el-descriptions-item label="内容">
                                                        <div style="background-color: #233858;" v-html="value.contentHtml"></div>
                                                    </el-descriptions-item>
                                                </el-descriptions>
                                            </div>
                                        </el-form>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="gmtCreate" width="150px" label="发送时间"></el-table-column>
                                <el-table-column prop="adminName" width="100px" label="后台操作人"></el-table-column>
                                <el-table-column prop="reason" width="100px" label="发送原因"></el-table-column>
                                <el-table-column width="100px" label="邮件标题">
                                    <template slot-scope="props">
                                        <div v-for="(value,key) in JSON.parse(props.row.contentJson)" :key="key">
                                            <span>{{value.title}}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="rewards" label="奖励"></el-table-column>
                                <el-table-column prop="disabledDays" width="100px" label="邮件有效期"></el-table-column>
                            </el-table>
                            <div class="pagination">
                                <el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
                                               :page-size="pageSize"
                                               layout="total, prev, pager, next, jumper" :total="totalRow">
                                </el-pagination>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane name="second" label="客服邮件发送">
                            <el-card>
                                <div slot="header" class="clearfix">
                                    <span>邮件奖励领取失效期</span>
                                </div>
                                <el-input-number v-model="endTime" :min="1" :max="100"></el-input-number>
                                <span>天</span>
                                <template>
                                    <span>快捷选项：</span>
                                    <el-button size="mini" @click="endTime = 7">一周后</el-button>
                                    <el-button size="mini" @click="endTime = 14">二周后</el-button>
                                    <el-button size="mini" @click="endTime = 30">一个月后</el-button>
                                    <el-button size="mini" @click="endTime = 90">三个月后</el-button>
                                </template>

                            </el-card>

                            <el-card>
                                <div slot="header" class="clearfix">
                                    <span>收件人</span>
                                </div>

                                <template>
                                    <component-query :queryMode="playerQueryMode" @usersData="getUsersData"></component-query>

                                    <!-- 查询用户数据 -->
                                    <!-- id,email,nick,level,status -->
                                    <el-table :data="players" border style="margin-top:10px;width: 100%"
                                              @selection-change="handleSelectionChange">
                                        <el-table-column type="selection" width="55"></el-table-column>
                                        <el-table-column prop="serverId" label="大区"></el-table-column>
                                        <el-table-column prop="userId" label="用户id"></el-table-column>
                                        <el-table-column prop="uri" label="用户ip"></el-table-column>
                                        <el-table-column prop="nick" label="昵称"></el-table-column>
                                        <el-table-column prop="level" label="等级"></el-table-column>
                                        <el-table-column label="禁言状态">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.silence == 0">正常</span>
                                                <span v-if="scope.row.silence == 1">禁言</span>
                                                <span v-if="scope.row.silence == 2">伪禁言</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="封号状态">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.block == 0">正常</span>
                                                <span v-if="scope.row.block == 1">后台封禁</span>
                                                <span v-if="scope.row.block == 2">系统封禁</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>

                                    <div>
                                        <el-button size="mini" type="primary" @click="confirmPlayer">确认添加</el-button>
                                    </div>

                                    <template>
                                        <span>收件人数：{{ confirmSendData.length }}</span>
                                    </template>

                                    <el-table :data="confirmSendData" border style="margin-top:10px;width: 100%">
                                        <el-table-column prop="serverId" label="大区"></el-table-column>
                                        <el-table-column prop="userId" label="用户id"></el-table-column>
                                        <el-table-column prop="uri" label="用户ip"></el-table-column>
                                        <el-table-column prop="nick" label="昵称"></el-table-column>
                                        <el-table-column prop="level" label="等级"></el-table-column>
                                        <el-table-column label="禁言状态">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.silence == 0">正常</span>
                                                <span v-if="scope.row.silence == 1">禁言</span>
                                                <span v-if="scope.row.silence == 2">伪禁言</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="封号状态">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.block == 0">正常</span>
                                                <span v-if="scope.row.block == 1">后台封禁</span>
                                                <span v-if="scope.row.block == 2">系统封禁</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>


                                </template>
                            </el-card>
                            <mail-editor
                                mailType="normal_mail"
                                :mailTemplateContent="mailTemplateContent"
                                :showTemplate="true"
                                :confirmSendMail="confirmSendMail"
                                @mailContent="getMailContent"
                                @rewardsStr="getRewardsStr"
                                :templateType="'kefu'">
                            </mail-editor>

                            <el-card>
                                <div slot="header" class="clearfix">
                                    <span>发送原因</span>
                                </div>
                                <el-autocomplete
                                    class="inline-input"
                                    type="textarea"
                                    :maxlength="300"
                                    show-word-limit
                                    :autosize="{ minRows: 2}"
                                    v-model="mailNormalSendForm.reason"
                                    :fetch-suggestions="querySearchrRasonTemplate"
                                    placeholder="请输入内容"
                                    @select="handleSelect"
                                >
                                    <template slot-scope="{ item }">
                                        <span class="addr">{{item.reason}}</span>
                                    </template>
                                </el-autocomplete>
                            </el-card>
                            <el-button type="primary" @click="showPostMail">发送</el-button>
                        </el-tab-pane>
                    </el-tabs>

                    <el-dialog title='发送邮件' :visible.sync="postMailShow" width="50%" lock-scroll center>
                        <div>
                            <el-card>
                                <div>收件人：</div>
                                <el-table :data="confirmSendData" border style="margin-top:20px;width: 100%">
                                    <el-table-column prop="serverId" label="大区"></el-table-column>
                                    <el-table-column prop="userId" label="用户id"></el-table-column>
                                    <el-table-column prop="uri" label="用户ip"></el-table-column>
                                    <el-table-column prop="nick" label="昵称"></el-table-column>
                                    <el-table-column prop="level" label="等级"></el-table-column>
                                    <el-table-column label="禁言状态">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.silence == 0">正常</span>
                                            <span v-if="scope.row.silence == 1">禁言</span>
                                            <span v-if="scope.row.silence == 2">伪禁言</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="封号状态">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.block == 0">正常</span>
                                            <span v-if="scope.row.block == 1">后台封禁</span>
                                            <span v-if="scope.row.block == 2">系统封禁</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-card>

                            <el-card>
                                <div slot="header" class="clearfix">
                                    <span>邮件内容</span>
                                </div>

                                <el-tabs v-model="editableTabsValue" type="card">
                                    <el-tab-pane
                                        v-for="(item2, index2) in langOptions"
                                        :key="item2.id"
                                        :label="item2.lang"
                                        :name="item2.val"
                                    >
                                        <template v-for="(value, key) in langGroups" v-if ="item2.val == key">
                                            <el-card>
                                                <el-form label-position="left" label-width="60px">
                                                    <el-form-item label='标题'>
                                                        {{value.title}}
                                                    </el-form-item>
                                                    <el-form-item label='发件人'>
                                                        {{value.sender}}
                                                    </el-form-item>
                                                    <el-form-item label='内容'>
                                                        {{value.contentHtml}}
                                                    </el-form-item>
                                                </el-form>
                                            </el-card>
                                        </template>
                                    </el-tab-pane>
                                </el-tabs>
                            </el-card>

                            <el-card>
                                <div slot="header" class="clearfix">
                                    <span>最终奖励串</span>
                                </div>

                                <div v-if="rewardsStr!==''">{{rewardsStr}}({{rewardsStrCN}})</div>
                            </el-card>

                            <el-card>
                                <div slot="header" class="clearfix">
                                    <span>发送原因</span>
                                </div>
                                <div>{{this.mailNormalSendForm.reason}}</div>
                            </el-card>
                        </div>
                        <div slot="footer" class="dialog-footer">
                            <el-button type="primary" @click="sendNormalMail" v-if="!isSendSuccess">发送</el-button>
                            <el-button class="rainbow-btn" type="primary" @click="postMailShow = false" v-if="isSendSuccess">发送成功，关闭窗口</el-button>
                        </div>
                    </el-dialog>
                </div>
            </section>
        </div>
    </el-card>
</template>

<script>
import paginationController from '../../mixins/pagination'
import actionConfirm from '../../mixins/action_confirm'
import lang_config from '../../data/lang_config.json';
import {
    mapState
} from 'vuex';
import mailEditor from '../../components/mail_editor'
import mailNormalApi from "../../service/mail_api";
import configSettingApi from '../../service/config_setting_api'
import componentQuery from '../../components/component_query'
import componentServer from '../../components/component_server'

export default {
    name: "normal_mails",
    data() {
        return {
            title: this.$route.meta.title,
            langOptions: lang_config,
            activeName: 'first',
            queryForm: {
                id: '',
                email: '',
                nick: ''
            },
            postMailData: [],
            playerQueryMode: ['mode_long_id','mode_short_id','mode_nick','mode_email'],
            langGroups: [],
            endTime: 30,
            players: [],
            // 普通邮件发送对象
            mailNormalSendForm: {
                adminName: '',
                disableDays: '',
                players: [],
                mailContents: [],
                rewards: '',
                reason: ''
            },
            mailTemplateContent: {
                'zh-Hans': {title: "", sender: "", content: [], contentHtml: ""},
                'zh-Hant': {title: "", sender: "", content: [], contentHtml: ""},
                'ja-JP': {title: "", sender: "", content: [], contentHtml: ""},
                'ko-KR': {title: "", sender: "", content: [], contentHtml: ""},
                'ru-RU': {title: "", sender: "", content: [], contentHtml: ""},
                'en-US': {title: "", sender: "", content: [], contentHtml: ""}
            },
            rewardsStr: '',
            rewardsStrCN: '',

            // 确认添加发送玩家
            confirmSendData: [],

            postMailShow: false,
            editableTabsValue: 'zh-Hans',
            confirmSendMail: false,

            optionMap:{
                '0':this.$t("reward_editor.39"),
                '1':this.$t("reward_editor.40"),
                '2':this.$t("reward_editor.41"),
                '3':this.$t("reward_editor.42"),
                '4':this.$t("reward_editor.43"),
                '5':'约束性道具',
                '6':this.$t("reward_editor.44"),
                '7':'战纹',
                '8':this.$t("reward_editor.46"),
                '9':this.$t("reward_editor.47"),
                '10':'回复类道具',
                '11':'头像',
                '12':'头像框',
                '13':'宝箱',
                '14':'皮肤',
                '15':'时效类道具',
                '16':'部落头像',
                '17':'起源盘',
                '18':'自选元核',
                '19':'进化光谱',
                '20':'聊天框',
                '21':'战斗框',
                '22':'元核碎片',
                '23':'元核髓',
            },
            optionValue: '0',
            count1: '',
            count2: '',
            countSwitch: false,
            rate: 0.1,
            value: '',
            emblemEntryConfigs: [],
            emblemLevel: 1,
            emblemStage: 0,
            emblemQuality: 1,
            emblemFate:0,
            emblemFateCustomizeTags:[],
            emblemFateCustomize:100,
            emblemMainProperty: 1,
            emblemFateProperty: 51,
            editEmblemEntries:[
                {
                    entry:[3, 0],
                    quality:0,
                    active:true
                },
                {
                    entry:[3, 0],
                    quality:0,
                    active:false
                },
                {
                    entry:[3, 0],
                    quality:0,
                    active:false
                },
                {
                    entry:[3, 0],
                    quality:0,
                    active:false
                },
                {
                    entry:[3, 0],
                    quality:0,
                    active:false
                },
                {
                    entry:[3, 0],
                    quality:0,
                    active:false
                },
            ],

            // 是否发送成功
            isSendSuccess: false,

            // 原因模板数据
            reasonTemplateData: [],

            delRewardsConfirm: false
        }
    },
    mixins: [paginationController, actionConfirm],
    computed: {
        ...mapState({
            token: state => state.user.userInfo.loginToken
        }),
    },
    mounted() {
        this.findAllNormalMails();
        this.getReasonListAll();
    },
    methods: {
        handleSelectionChange(val) {
            this.postMailData = val;
        },

        confirmPlayer() {
            var data = [];
            var obj = {};

            if (this.confirmSendData.length > 0) {
                this.confirmSendData = this.confirmSendData.concat(this.postMailData);

                for (var i =0; i < this.confirmSendData.length; i++) {
                    if (!obj[this.confirmSendData[i].userId]) {
                        data.push(this.confirmSendData[i]);
                        obj[this.confirmSendData[i].userId] = true;
                    }
                }

                this.confirmSendData = data;
            } else {
                this.confirmSendData = this.postMailData;
            }
        },
        /**
         * 查询用户数据
         */
        getUsersData(val) {
            console.log(val)
            var players = [];
            val.forEach(item => {
                players.push({
                    uri: item.uri,
                    serverId: item.server,
                    userId: item.id,
                    email: item.email,
                    nick: item.nick,
                    level: item.level,
                    silence: item.silence,
                    block: item.block
                })
            })
            this.players = players;
        },
        //普通邮件-查询全部
        findAllNormalMails() {
            let self = this;
            mailNormalApi.findAllNormalMails({
                token: self.token
            }).then(res => {
                res.forEach(item => {
                    item.rewards = item.rewards + (item.rewards?'(':'') + self.formatterRewardsToCN(item.rewards) + (item.rewards?')':'');
                })
                self.rawData = res;
                self.totalRow = res.length;
            })
        },
        // 获取邮件内容编辑器信息
        getMailContent(val) {
            this.langGroups = val;
        },
        getRewardsStr(val) {
            this.rewardsStr = val;
        },
        // 普通邮件
        sendNormalMail() {
            let self = this;
            let data = self.mailNormalSendForm;
            data.adminName = self.adminName;
            data.disableDays = self.endTime;
            data.players = self.confirmSendData;
            data.mailContents = self.langGroups;
            data.rewards = self.rewardsStr;

            mailNormalApi.sendNormalMail({
                token: self.token,
                sendForm: self.mailNormalSendForm
            }).then(res => {
                this.isSendSuccess = true;
                self.$message({
                    type: 'success',
                    message: '发送成功'
                });
            })
        },

        showPostMail() {
            this.confirmSendMail = true;
            this.isSendSuccess = false;

            setTimeout(() => {
                this.postMailShow = true;
                this.confirmSendMail = false;
                this.rewardsToCN(this.rewardsStr)
            },1000)

        },

        formatterRewardsToCN(row) {
            var arr = row.split(',');
            var result = '';
            arr.forEach(item => {
                if (item !== '') {
                    this.resolveRewardStr(item);

                    let optionValueCN = this.optionMap[this.optionValue];
                    let idCn = this.getIdCn(this.optionValue,this.value);
                    let finalCount = '';
                    if (this.countSwitch) {
                        finalCount = this.count1 + "-" + this.count2;
                    } else {
                        finalCount = this.count1
                    }
                    let finalContentCN = optionValueCN + "$" + idCn + "_" + finalCount;
                    result = result + (result?',':'') + finalContentCN;
                }

            })
            return result;
        },

        rewardsToCN(rewards) {
            var arr = rewards.split(',');
            var result = '';
            arr.forEach(item => {
                if (item !== '') {
                    this.resolveRewardStr(item);

                    let optionValueCN = this.optionMap[this.optionValue];
                    let idCn = this.getIdCn(this.optionValue,this.value);
                    let finalCount = '';
                    if (this.countSwitch) {
                        finalCount = this.count1 + "-" + this.count2;
                    } else {
                        finalCount = this.count1
                    }
                    let finalContentCN = optionValueCN + "$" + idCn + "_" + finalCount;
                    result = result + (result?',':'') + finalContentCN;
                }

            })

            this.rewardsStrCN = result;
        },

        resolveRewardStr(str){
            let self = this;

            if (str == '') {
                self.countSwitch = false;
                self.rateSwitch = false;
                self.isDetail = false;
                self.count1 = 1;
                self.count2 = 1;
                self.rate = 0.1;
                self.emblemLevel = 1;
                self.emblemStage = 0;
                self.emblemQuality = 1;
                self.emblemMainProperty = 1;
                self.emblemFate = 0;
                self.emblemFateCustomize = 100;
                self.emblemFateProperty = 51;

                self.editEmblemEntries = [
                    {
                        entry:[3, 0],
                        quality:0,
                        active:true
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                ]
            }

            let rewardArray = str.toString().split("_");

            for (let index = 0; index < rewardArray.length; index++) {
                const element = rewardArray[index];
                switch (index) {
                    case 0:
                        let bigTypeArry = element.split("$");
                        //大类
                        self.optionValue = bigTypeArry[0];
                        //identify
                        self.value = parseInt(bigTypeArry[1]);
                        if (self.value == 50001) {
                            self.emblemRandomByQuality = false;
                        } else {
                            self.emblemRandomByQuality = true;
                        }
                        break;
                    case 1:
                        //数量
                        let countArry = element.split("-");
                        if(countArry.length>1){
                            self.countSwitch = true;
                            self.count1 = countArry[0];
                            let rateAndCount = countArry[1].split('|');
                            if (rateAndCount.length>1) {
                                self.rateSwitch = true;
                                self.count2 = rateAndCount[0];
                                self.rate = rateAndCount[1];
                            } else {
                                self.rateSwitch = false;
                                self.count2 = countArry[1];
                            }
                        }else{
                            self.countSwitch = false;

                            let rateAndCount = countArry[0].split('|');
                            if (rateAndCount.length>1) {
                                self.rateSwitch = true;
                                self.count1 = rateAndCount[0];
                                self.rate = rateAndCount[1];
                            } else {
                                self.rateSwitch = false;
                                self.count1 = countArry[0];
                            }
                        }
                        break;
                    case 2:
                        //等级
                        self.emblemLevel = parseInt(element);

                        if (self.optionValue == '7') {
                            self.warGrooveQuality = parseInt(element);
                        }
                        break;
                    case 3:
                        //阶段
                        self.emblemStage = parseInt(element);

                        if (self.optionValue == '7') {
                            if (element) {
                                self.warGrooveChannelSwitch = true;
                                self.warGrooveChannelUp = parseInt(element);
                            } else {
                                self.warGrooveChannelSwitch = false;
                            }
                        }
                        break;
                    case 4:
                        //品质
                        self.emblemQuality = parseInt(element);

                        if (self.optionValue == '7') {
                            self.warGrooveChannelDown = parseInt(element);
                        }
                        break;
                    case 5:
                        //宿命
                        let fateArray = element.split("#");
                        self.emblemFate = 3;
                        if(fateArray.length>1){
                            for (let i = 0; i < fateArray.length; i++) {
                                const element = fateArray[i];
                                let item = fateArray.splice("@");
                                self.emblemFateCustomizeTags[i] = {id:parseInt(item[0]),chance:parseInt(item[1])}
                            }
                        }else{
                            if(element>0){
                                self.emblemFate = 2;
                                self.emblemFateProperty = parseInt(element);
                            }else{
                                self.emblemFate = 0;
                            }
                        }

                        if (self.optionValue == '7') {
                            self.warGrooveChannelLeft = parseInt(element);
                        }

                        break;
                    case 6:
                        //宿命自定义概率
                        self.emblemFateCustomize = parseInt(element*100);

                        if (self.optionValue == '7') {
                            self.warGrooveChannelRight = parseInt(element);
                        }
                        break;
                    case 7:
                        //主属性
                        self.emblemMainProperty = parseInt(element);
                        break;
                    case 8:
                        //词条属性
                        let entryArray = element.split("#");
                        for (let index = 0; index < entryArray.length; index++) {
                            const entryItem = entryArray[index];
                            let current = self.editEmblemEntries[index];

                            self.emblemEntryConfigs.forEach(item => {
                                item.children.forEach(iitem => {
                                    if (iitem.value == entryArray[index].split('@')[0]&&entryArray[index].split('@').length>1) {
                                        self.editEmblemEntries[index].entry = [item.value,iitem.value];
                                        self.editEmblemEntries[index].active = true;
                                    } else {
                                        self.editEmblemEntries[index].active = false;
                                    }
                                })
                            })

                            self.editEmblemEntries[index].quality = parseInt(entryArray[index].split('@')[1]);
                        }

                        let countAndEntry = entryArray[entryArray.length-1].split('|');
                        if (countAndEntry.length>1) {
                            self.rateSwitch = true;
                            self.rate = countAndEntry[1];
                        } else {
                            self.rateSwitch = false;
                        }
                        break;
                    default:
                        break;
                }
            }
        },

        getIdCn(optionValue,id){
            let self = this;
            if(optionValue == "0" || optionValue == "3" || optionValue == "4" || optionValue == "5" || optionValue == "9" ||
                optionValue == "10" || optionValue == "11" || optionValue == "12" || optionValue == "13" || optionValue == "14" ||
                optionValue == "15"){
                //道具
                return self.$t('propConfigName_'+id);
            }else if(optionValue == "1"){
                //怪兽
                return self.$t('monsterName_' + id);
            }else if(optionValue == "2"){
                //怪兽碎片
                return self.$t('monsterName_' + ((id>>0)-10000)) + "碎片";
            }else if(optionValue == "6"){
                //怪兽觉醒水晶
                return self.$t('monsterName_' + ((id>>0)-20000)) + "觉醒结晶";
            }else if(optionValue == "8"){
                //怪兽觉醒水晶碎片
                return self.$t('monsterName_' + ((id>>0)-30000)) + "觉醒结晶碎片";
            }else if(optionValue == "7"){
                //战纹
                return self.$t('warGrooveConfigName_' + id);
            }else if(optionValue == "17"){
                //战纹
                return "起源盘";
            }
        },
        // 模板列表查询
        getReasonListAll() {
            configSettingApi.reasonList({
                token: this.token
            }).then(res => {
                this.reasonTemplateData = res;
            })
        },

        querySearchrRasonTemplate(queryString, cb) {
            var data = this.reasonTemplateData;
            var results = queryString ? data.filter(this.createFilter(queryString)) : data;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },

        createFilter(queryString) {
            return (data) => {
                return (data.reason.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handleSelect(item) {
            this.mailNormalSendForm.reason = item.reason;
        }
    },
    components: {
        mailEditor,
        componentQuery,
        componentServer
    }
}
</script>

<style scoped lang="less">
    .reward-text {
        color: #5daf34;
    }

    .rainbow-btn {
        background:linear-gradient(45deg,#ff0000 0%,#ffb600 11%,#fff600 22%,#a5ff00 33%,#00a9ff 44%,#0400ff 55%,#8a00fc 66%,#ff00e9 77%,#ff0059 88%,#ff0000 100%);
        border: none;
    }
    .inline-input {
        width: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/views/mails/kf_mails.vue